'use client';

import { twMerge } from '@shared/themes';
import type { ContentSwitcherProps, Option } from '../types';
import { ContentSwitcherButton } from './components/ContentSwitcherButton/ContentSwitcherButton';

function ContentSwitcher<T>({
  id,
  options,
  value,
  onChange,
  size,
  showBackground = true,
  disabled = false,
  className,
  fullWidth = false,
  buttonClassName,
  ...props
}: ContentSwitcherProps<T>) {
  const sizeClasses = size === 'small' ? 'gap-2' : 'gap-3';
  const classes = twMerge('flex', fullWidth ? 'w-full' : 'w-fit', sizeClasses, showBackground && 'p-1 rounded-full bg-container', className);

  const handleOnClick = (option: Option<T>) => {
    if (option && !disabled && onChange) {
      onChange(option);
    }
  };
  return (
    <div id={id} role="radiogroup" className={classes} aria-disabled={disabled} aria-hidden={disabled} data-track-container="Segmentation" {...props}>
      {options.map((option: Option<T>) => (
        <ContentSwitcherButton
          key={option.value?.toString() ?? ''}
          option={option}
          checked={option.value === value?.value}
          onClick={handleOnClick}
          size={size}
          disabled={disabled}
          className={twMerge(fullWidth && 'flex-1', buttonClassName)}
          data-testid={option['data-testid']}
        />
      ))}
    </div>
  );
}

export { ContentSwitcher };
